import { render, staticRenderFns } from "./StockeChips.vue?vue&type=template&id=3a1bd252"
import script from "./StockeChips.vue?vue&type=script&lang=js"
export * from "./StockeChips.vue?vue&type=script&lang=js"
import style0 from "./StockeChips.vue?vue&type=style&index=0&id=3a1bd252&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports